import { EntityAPIGatewayCard } from '@internal/plugin-api-gateway';
import {
  EntityApiDefinitionCard,
  EntityApiGovernanceCard,
  EntityConsumingComponentsCard,
  EntityProvidingComponentsCard,
} from '@internal/plugin-api-governance';
import React from 'react';

import { FeatureFlagged } from '@backstage/core-app-api';
import { EntityLayout, EntityLinksCard } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

import { Grid } from '@material-ui/core';

import { ActionContent, EntityWarningContent } from '../Content';
import { APIAboutCard } from '../Content/APIAboutCard';

export const ApiPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        <EntityWarningContent />
        {ActionContent}
        <Grid item md={6}>
          <APIAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
        <Grid item md={4} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid container item md={12}>
          <Grid item md={6}>
            <EntityProvidingComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityConsumingComponentsCard />
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/governance" title="Governance">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiGovernanceCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <FeatureFlagged with="show-api-gateway-proxy-management">
      <EntityLayout.Route path="/central-gateway" title="Central Gateway">
        <EntityAPIGatewayCard />
      </EntityLayout.Route>
    </FeatureFlagged>
  </EntityLayout>
);
